var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3696 0.582187L11.1758 28.1597L13.5771 28.5191L17.771 0.941655L15.3696 0.582187Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8689 15.0085L4.95703 25.9899L6.84862 27.501L15.7605 16.5196L13.8689 15.0085Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2878 1.43737L20.6209 27.9919L17.9817 29.0028L7.64865 2.44827L10.2878 1.43737Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07384 5.81992L2.55078 7.69666L13.505 16.4474L15.0281 14.5707L4.07384 5.81992Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.395628 12.7516L0.0488281 15.1364L14.1303 17.1521L14.4771 14.7673L0.395628 12.7516Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2729 14.3727L11.1758 28.1631L13.5771 28.5226L15.6743 14.7321L13.2729 14.3727Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2495 14.1459L16.3236 16.8527L2.71194 22.1696L1.63781 19.4628L15.2495 14.1459Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bc1a91295682251bedaa729a1daf553.svg";
export { ForwardRef as ReactComponent };